module.exports = __webpack_public_path__ + "static/img/14.46c6918.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/14.svg
// module id = ScP2
// module chunks = 0